import { render, staticRenderFns } from "./Administracion.vue?vue&type=template&id=7729b6ee"
import script from "./Administracion.vue?vue&type=script&lang=js"
export * from "./Administracion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7729b6ee')) {
      api.createRecord('7729b6ee', component.options)
    } else {
      api.reload('7729b6ee', component.options)
    }
    module.hot.accept("./Administracion.vue?vue&type=template&id=7729b6ee", function () {
      api.rerender('7729b6ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/Administracion.vue"
export default component.exports